import update from "immutability-helper";
import {
    CONVERSATION_INIT,
    NEW_CONVERSATION_INIT,
    ADD_MESSAGE_BEGIN,
    ADD_MESSAGE_SUCCESS,
    UPLOAD_FILE_MESSAGE_BEGIN,
    UPLOAD_FILE_MESSAGE_SUCCESS,
    CHAT_CONVERSATION_LIST_FINISH,
    MESSAGE_LIST_FETCH_POLLING,
    MESSAGE_LIST_FETCH_FINISH,
    CHAT_MESSAGES_USER_LIST_FETCH_FINISH,
    // MESSAGE_CENTER_RESET,
} from "actions/messageCenterActions";

const INITIAL_STATE = {
    selectedSupplierId: null,
    conversations: [],
    messageList: [],
    newMessageUserList: [],
    status: "idle",
};

export default function messageCenterReducer(state = INITIAL_STATE, { type, data }) {
    switch (type) {
        case CONVERSATION_INIT:
            return {
                ...state,
                selectedSupplierId: null,
            };
        case NEW_CONVERSATION_INIT:
            return {
                ...state,
                selectedSupplierId: data.id,
                conversations: [data, ...state.conversations],
            };

        case CHAT_CONVERSATION_LIST_FINISH:
            return {
                ...state,
                conversations: data,
            };

        case MESSAGE_LIST_FETCH_POLLING:
            return {
                ...state,
                messageList: [],
                status: "fetching",
            };

        case MESSAGE_LIST_FETCH_FINISH:
            return {
                ...state,
                selectedSupplierId: data.supplierId,
                messageList: [...state.messageList, ...data.messageList],
                status: "idle",
            };

        case ADD_MESSAGE_BEGIN:
            return {
                ...state,
                status: "fetching",
            };

        case ADD_MESSAGE_SUCCESS:
            return update(state, {
                messageList: { $push: [data] },
                status: { $set: "idle" }
            });

        case UPLOAD_FILE_MESSAGE_BEGIN:
            return {
                ...state,
                status: "fetching",
            };

        case UPLOAD_FILE_MESSAGE_SUCCESS:
            return {
                ...state,
                messageList: [...state.messageList.filter(item => item.id !== data.id), data],
                status: "idle",
            };

        case CHAT_MESSAGES_USER_LIST_FETCH_FINISH:
            return {
                ...state,
                newMessageUserList: data,
            };

        default:
            return state;
    }
}
